import { useEffect, useState } from 'react';
import { getConsentStatus, setConsentStatus, initPostHog } from '@/utils/cookieConsent';

export function CookieBanner() {
  // Default to hidden so the prerendered marketing HTML (which has no
  // localStorage access) and the client's first paint produce identical
  // markup — preventing a hydration mismatch. The effect below decides
  // whether the banner should actually appear.
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getConsentStatus() === null) setVisible(true);
  }, []);

  if (!visible) return null;

  const accept = async () => {
    setConsentStatus('granted');
    initPostHog();
    try {
      const { supabase } = await import('@/integrations/supabase/client');
      const { data } = await supabase.auth.getSession();
      const userId = data.session?.user?.id;
      if (userId && window.posthog) {
        window.posthog.identify(userId);
      }
    } catch {
      // Best-effort identification — banner still closes if Supabase fails.
    }
    setVisible(false);
  };

  const decline = () => {
    setConsentStatus('denied');
    setVisible(false);
  };

  return (
    <div className="gw-cookie">
      <div className="gw-cookie-row">
        <p className="gw-cookie-copy">
          We use analytics to understand how Guiri is used and improve it.
          See our{' '}
          <a href="/privacy" className="gw-cookie-link">Privacy Policy</a>.
        </p>
        <div className="gw-cookie-actions">
          <button onClick={decline} className="gw-cookie-decline" type="button">Decline</button>
          <button onClick={accept} className="gw-cookie-accept" type="button">Accept</button>
        </div>
      </div>
    </div>
  );
}
